import { useCallback, useEffect, useRef } from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
//
import { selectPictureOrigin } from 'redux/selector/app'
//
import { fetchBinFile, fetchPostAdEvent, SchemaOholoMaterialShow } from 'api'
//
import { imageParser } from 'utils/imageParser'
//
import { Wrapper, AdImage, BtnCancel } from './Styled'
import { patchUrlProtocol } from 'utils/urlUtils'
import { formatDate } from 'utils/timeFormat'
import { catchPromiseCancel } from 'utils/catchPromiseCancel'

interface AdItemProps extends SchemaOholoMaterialShow {
  currentDisplayAnnouncement: { id?: string }
  handleCancel?: () => void
  [key: string]: any
}

export default function AdItem(info: AdItemProps) {
  const pictureOrigin = useSelector(selectPictureOrigin)
  const imgRef = useRef<HTMLImageElement>(null)

  const fetchedSrc = useRef<string | null>(null)
  useEffect(() => {
    const shortcutImagePath = `${pictureOrigin}/${info?.icon_path}`

    if (!pictureOrigin || !info?.icon_path || (imgRef.current?.src && fetchedSrc.current === shortcutImagePath)) return

    const controller = new AbortController()

    fetchBinFile({
      url: shortcutImagePath,
      signal: controller.signal,
    })
      .then((textBase64) => {
        fetchedSrc.current = shortcutImagePath
        if (imgRef.current) {
          imgRef.current.src = imageParser(textBase64)
        }
      })
      .catch(catchPromiseCancel)

    return () => {
      controller.abort()
    }
  }, [pictureOrigin, info])

  const handleOnClick = useCallback(() => {
    if (info) {
      if (!info.link) {
        console.warn('ad link missing')
        return
      }
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: info.id,
        material_name: info.name as string,
        oholo_site_id: info.site_type,
        oholoer_id: info.oholoer_id,
        oholoer_link: info.oholoer_link,
        oholoer_name: info.oholoer_name,
      })
      const link = patchUrlProtocol(info.link)
      window.open(link, '_blank')
    } else {
      console.warn('no ad assigned')
    }
  }, [info])

  if (!pictureOrigin) return null

  return (
    <Wrapper
      className={classnames({
        visible: info.currentDisplayAnnouncement.id === info.id,
      })}
      onClick={info?.handleCancel}
    >
      <AdImage ref={imgRef} onClick={handleOnClick} />

      <BtnCancel data-testid="close_ad_announcement" aria-label="close_ad_announcement" onClick={info?.handleCancel} />
    </Wrapper>
  )
}
